export const truncateNumUtil = (num) => {
    return Math.trunc(num*100)/100
}
